// extracted by mini-css-extract-plugin
module.exports = {"catalogPage":"catalog_catalogPage__V6BMA","hero":"catalog_hero__uT16C","heroContainer":"catalog_heroContainer__dtSVb"};